module.exports = __webpack_public_path__ + "static/people-grow-potted-plants-2x-335f117ac5d34c93c748950375bce105.jpg";